import { useProducts } from "hooks/useDataFetch";
import MaterialTable from "@material-table/core";

import React from "react";
import { muiTable } from "utils";
import { Avatar, Button, Switch } from "@mui/material";
import { PhotoUpload } from "dashboard/components/core";
import { useNavigate } from "react-router-dom";
import { formatCurrency } from "@ashirbad/js-core";
import { db } from "hooks";
import Swal from "sweetalert2";
import { Edit } from "@mui/icons-material";
const ViewProducts = () => {
  const { data, loading } = useProducts();

  const navigate = useNavigate();

  // console.log(data);

  const handleProductBlock = async (rowData, e) => {
    try {
      const isBlocked = e.target.checked;

      const { id } = rowData;

      await db.updateDb(`/products/${id}`, {
        isBlocked,
      });
    } catch (error) {
      console.log(error);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  return (
    <main className="dashboard-user-manage">
      <MaterialTable
        title="View Products"
        isLoading={!data && loading}
        data={data || []}
        options={{ ...muiTable.options() }}
        style={muiTable.styles}
        columns={[
          {
            title: "#",
            field: "sl",
            width: "5%",
            editable: "never",
            id: "sl",
          },
          {
            title: "Product",
            field: "images",
            render: (rowData) => (
              <Avatar
                src={rowData?.images && rowData?.images[0]?.url}
                variant="rounded"
                sx={{ width: 60, height: 60 }}
              />
            ),
            width: "5%",
            editComponent: ({ value, onChange }) => (
              <PhotoUpload value={value} onChange={onChange} />
            ),
          },
          {
            title: "Name",
            field: "name",
          },
          {
            title: "Price",
            field: "price",
            render: ({ price }) => {
              return formatCurrency(price, "SAR");
            },
          },
          {
            title: "Offer",
            field: "discount",
            // render: (rowData) => {
            //   let totalPrice = rowData.price + rowData.discount;
            //   return (
            //     (totalPrice * rowData?.discount) / 100?.toFixed(0) + " % OFF "
            //   );
            // },
            render: ({ discount }) => {
              console.log(discount);
              return `${discount} % OFF`;
            },
          },
          {
            title: "Purchased",
            field: "totalSold",
            type: "numeric",
          },
          {
            title: "Stock",
            field: "quantity",
            type: "numeric",
          },
          {
            title: "Water Amount",
            field: "waterQuantity",
            render: (rowData) => {
              return rowData?.waterQuantity + " ml";
            },
          },
          {
            title: "Supplier",
            field: "supplierName",
          },
          {
            title: "On Sale",
            field: "onSale",
            render: (rowData) => {
              return rowData.discount ? (
                <span
                  style={{
                    backgroundColor: "#80ff8540",
                    color: "#005e01",
                    borderRadius: "20rem",
                    border: "1px solid #2cf63ccc",
                    padding: "0.2rem 1rem",
                  }}
                >
                  Yes
                </span>
              ) : (
                <span
                  style={{
                    backgroundColor: "#ff777740",
                    color: "#5c0000",
                    borderRadius: "20rem",
                    border: "1px solid #ff14145c",
                    padding: "0.2rem 1rem",
                  }}
                >
                  No
                </span>
              );
            },
          },
          {
            title: "Blocked",
            field: "isBlocked",
            render: (rowData) => {
              return (
                <Switch
                  checked={rowData?.isBlocked}
                  onClick={(e) => handleProductBlock(rowData, e)}
                />
              );
            },
          },

          {
            title: "Actions",
            render: (rowData) => {
              return (
                <div className="flex-row gap-1">
                  {/* <Button
                    className="view-supplier-btn"
                    onClick={() => {
                      // console.log(rowData);
                      navigate(`/admin/suppliers/viewdetails/${rowData?.id}`);
                    }}
                  >
                    View
                  </Button> */}
                  <Button
                    startIcon={<Edit />}
                    className="view-supplier-btn-edit"
                    onClick={() => {
                      // console.log(rowData);
                      navigate(`/admin/products/edit/${rowData?.id}`);
                    }}
                  >
                    Edit
                  </Button>
                </div>
              );
            },
          },
        ]}
      />
    </main>
  );
};

export default ViewProducts;
